<template>
  <div class="homePage" id="tinyScreenHome">
    <Header></Header>
    <div class="bannerBox pcShow" style="height: 620px;">
      <el-carousel height="620px" :arrow="pcAdvertUrl.length === 1?'never':''" :indicator-position="pcAdvertUrl.length === 1?'none':''">
        <el-carousel-item v-for="(item,index) in pcAdvertUrl" :key="index">
          <div class="bannerPic" @click="goPage(item)" :style="{backgroundImage:'url('+item.pcUrl+')'}">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="bannerPhonePic phoneShow" :style="{height: scrollerHeight}">
       <el-carousel width="width" :arrow="mobileAdvertUrl.length === 1?'never':''" :height="scrollerHeight" :indicator-position="mobileAdvertUrl.length === 1?'none':''">
        <el-carousel-item v-for="(item,index) in mobileAdvertUrl" :key="index">
             <div class="pic"  @click="goPage(item)" :style="{height: scrollerHeight,backgroundImage:'url('+item.phoneUrl+')'}">
             </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- section1 -->
    <div class="section1 middle container">
      <div class="txt">
        <div>
        <h4>{{$t('home.section1')}}</h4>
        <div class="content" v-html="content"></div>
        <div class="more" @click="goAbout">
          <span>{{$t('home.more')}}</span>
        </div>
        </div>
<!--       <img height="100%" src="../assets/picture/homePic/home1.png"> -->
      </div>
    </div>
    <!-- section2 -->
    <div class="section2 middle mt60 flex container mb120">
      <div class="mr23 box" @click="goStory" :style="{backgroundImage:storyAdvertUrl?'url('+storyAdvertUrl+')':'url('+require('../assets/picture/homePic/p1.png')+')'}">
        <p class="title2">{{storySubTxt}}</p>
        <p class="title3">{{storyTxt}}</p>
      </div>
      <div class="mr23 box" @click="goResponsibility" :style="{backgroundImage:respnsibilityAdvertUrl?'url('+respnsibilityAdvertUrl+')':'url('+require('../assets/picture/homePic/p2.png')+')'}">
        <p class="title2">{{respnsibilitySubTxt}}</p>
        <p class="title3">{{respnsibilityTxt}}</p>
      </div>
      <div class="box lastBox" @click="goOccupation">
        <img class="pic" src="../assets/picture/homePic/t11.png">
        <p class="title4">{{$t('home.occupation')}}</p>
        <p class="title5">{{$t('home.occupationSub')}}</p>
        <div class="more">
          <span>
          {{$t('home.more')}}
          <img class="moreIcon" width="10px" src="../assets/picture/homePic/right.png">
          </span>
        </div>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header';
import Footer from './common/footer';
export default {
  data() {
    return {
      content:'',
      width:0,
      height:0,
      scrollerHeight:'',
      pcAdvertUrl:[],
      mobileAdvertUrl:[],
      mobileRespnsibilityAdvertUrl:'',
      pcRespnsibilityAdvertUrl:'',
      mobileStoryAdvertUrl:'',
      pcStoryAdvertUrl:'',
      storyAdvertUrl:'',
      respnsibilityAdvertUrl:'',
      storyTxt:'',
      storySubTxt:'',
      respnsibilityTxt:'',
      respnsibilitySubTxt:'',
      lang:'',
    };
  },
  components: {Header,Footer},  
  computed: {
    // 滚动区高度 
    // scrollerHeight: function() {
    //   return (window.innerHeight) + 'px'; //自定义高度需求
    // },
    marginTop: function() {
      return (window.innerHeight-800)/2 + 'px'; //自定义高度需求
    },
  },
  mounted(){
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
    this.getJiaQiTouzi();
    this.getAdvert();
    this.getStoryAdvert();
    this.getRespnsibilityAdvert();
    this.width =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.height =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if(this.width<1023){
      this.scrollerHeight = (window.innerHeight) + 'px';
    }
  },
  methods: {
    goOccupation(){
      this.$router.push({  
            path: '/careers'  
        })
    },
    goResponsibility(){
      this.$router.push({  
            path: '/responsibility'  
        }) 
    },
    goAbout(){
      this.$router.push({  
            path: '/about'  
        }) 
    },
    goStory(){
       this.$router.push({  
            path: '/story'  
        }) 
    },
    // 获取首页佳期投资
    async getJiaQiTouzi() {
        const { data: res } = await this.$http.get("/article/getJiaQiTouzi.do");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.content = res.data.content;
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=2");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        let pcUrl = [];
        let phoneUrl = [];
        let urlList = [];
        pcUrl = res.data[0].pcAdvertUrl.split(',');
        phoneUrl = res.data[0].mobileAdvertUrl.split(',');
        urlList = res.data[0].url.split(',');
        for (var i = 0; i < pcUrl.length; i++) { 
          let pcItem = {
            pcUrl:pcUrl[i],
            url:urlList[i]
          }
          let phoneItem = {
            phoneUrl:phoneUrl[i],
            url:urlList[i]
          }
          this.pcAdvertUrl.push(pcItem);
          this.mobileAdvertUrl.push(phoneItem);
        }
    },
    // 根据埋点ID及非必填项获取广告位,首页_一期一故事广告
    async getStoryAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=12");
        if (res.code !== 200) return this.$message.error(res.message);
        this.pcStoryAdvertUrl = res.data[0].pcAdvertUrl;
        this.mobileStoryAdvertUrl = res.data[0].mobileAdvertUrl;
        if(this.lang == 'en'){
          this.storyTxt = res.data[0].enContent;
          this.storySubTxt = res.data[0].enSubContent;
        }else{
          this.storyTxt = res.data[0].cnContent;
          this.storySubTxt = res.data[0].cnSubContent;
        }
         if(this.width<1023){
          this.storyAdvertUrl = this.mobileStoryAdvertUrl;
        }else{
          this.storyAdvertUrl = this.pcStoryAdvertUrl;
        }
    },
    // 广告图点击跳转
    goPage(item){  
      if(item.url){
        let url = item.url;
        window.location.href = url;
      }
    },
    // 根据埋点ID及非必填项获取广告位,首页_社会责任
    async getRespnsibilityAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=13");
        if (res.code !== 200) return this.$message.error(res.message);
        this.pcRespnsibilityAdvertUrl = res.data[0].pcAdvertUrl;
        this.mobileRespnsibilityAdvertUrl = res.data[0].mobileAdvertUrl;
        if(this.lang == 'en'){
          this.respnsibilityTxt = res.data[0].enContent;
          this.respnsibilitySubTxt = res.data[0].enSubContent;
        }else{
          this.respnsibilityTxt = res.data[0].cnContent;
          this.respnsibilitySubTxt = res.data[0].cnSubContent;
        }
        
        if(this.width<1023){
          this.respnsibilityAdvertUrl = this.mobileRespnsibilityAdvertUrl;
        }else{
          this.respnsibilityAdvertUrl = this.pcRespnsibilityAdvertUrl;
        }
    },
  }
};
</script>

<style lang="less" scoped>
.homePage{
  .bannerPhonePic{
       .pic{
          cursor: pointer;
          width: 100%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-image: url(../assets/picture/homePic/phone/bannerHome.png);
       } 
    }
  .bannerBox{
     width:100%;  
     position:relative;  
     overflow:hidden;  
     height:620px; 
    /deep/ .el-carousel__arrow{
      top:auto !important;
      bottom: 35px !important;
      display: block !important;
      background: none;
    }
    /deep/ .el-carousel__arrow--right{
      right: 30%;
    }
     /deep/ .el-carousel__arrow--left{
      left: 30%;
    }
    /deep/ .el-carousel__indicator--horizontal{
      padding:12px !important;
    }
    /deep/ .el-carousel__indicators--horizontal{
      bottom: 55px !important;
      padding:0 24px;
    }
    .el-carousel__button{
      width: 60px !important;
    }
    .bannerPic{
      /*width:auto;
      height:100%;
      display:flex;
      align-items:center; 
      justify-content:center;*/
      width:1920px; /*图片宽度*/  
      position:absolute;  
      left:50%;  
      margin-left:-960px; /*图片宽度的一半*/  
      cursor: pointer;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .el-carousel__item h3 {
      color: #fff;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }
  }
  /*****************************************/
  .section1{
    margin-top:70px;
    background:#900211;
    /*height: 370px;*/
    display: flex;
    position: relative;
    img{
      position: absolute;
      right: 0;
      bottom: 0;
    }
    h4{
      font-size: 28px;
      color: #F2F2F2;
      margin:64px 0 0 120px;
    }
    .content{
      width: 80%;
      /*height: 111px;*/
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #F2F2F2;
      line-height: 28px;
      margin-left: 120px;
      margin-top: 15px;
      display:block;
      overflow: hidden;      
      text-overflow: ellipsis;      
      display: -webkit-box;     
      -webkit-line-clamp: 4;    
      -webkit-box-orient: vertical; 
      p{
        display: none;
        background: none;
      }
      /deep/ span{
        background: none !important;
        color: #fff !important;
      }
   /*   p:nth-of-type(1){
        display:block;
         overflow: hidden;      
        text-overflow: ellipsis;      
        display: -webkit-box;     
        -webkit-line-clamp: 4;    
        -webkit-box-orient: vertical; 
      };   */
    }
    .more{
      width: 130px;
      height: 44px;
      border: 1px solid #F2F2F2;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #F2F2F2;
      margin-left: 120px;
      margin-top: 36px;
      text-align: center;
      line-height: 44px;
      cursor:pointer;
      margin-bottom: 70px;
    }
  }
  .section2{
    .box{
       background-position: center center;  
    }
    .box:nth-of-type(1){
        background-image:url(../assets/picture/homePic/p1.png);
        background-size: cover;
        background-repeat: no-repeat;
      };
      .box:nth-of-type(3){
        background:#900211;
        img{
          margin-left: 24px;
          margin-top: 35px;
          height: 80px;
          width: 80px;
          float: inherit;
        }
        .title4{
            margin-left: 30px;
            margin-top: 26px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #F2F2F2;
            line-height: 37px;
          }
          .title5{
            margin-left: 30px;
            margin-top: 10px;                       
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #F2F2F2;
            line-height: 20px;
            letter-spacing: 1px;
          }
          .more{
            margin-top: 37px;
            margin-left: 30px;
            width: 136px;
            height: 44px;
            border: 1px solid #F2F2F2;
            line-height: 44px;
            color:#f2f2f2;
            cursor: pointer;
            span{
              margin-left: 26px;
            }
            .moreIcon{
              margin-right: 26px;
              margin-top: 17px;
              float: right;
              width: 10px;
              height: 10px;
              margin-left: 0;
            }
          }
      };
      .box:nth-of-type(2){
        background-image:url(../assets/picture/homePic/p2.png); 
        background-size: cover;
        background-repeat: no-repeat;
      };
    .box{
      height: 327px;
      width: 33%;
      position:relative;
      .title2{
        position: absolute;
        left: 30px;
        bottom: 82px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        letter-spacing: 1px;
      }
       .title3{
        position: absolute;
        left: 30px;
        bottom: 35px;       
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 37px;
      }
    }
  }
}
</style>
